import { setCommonHeaders } from '_api/base';
import useApiMutation from '_api/mutations/useApiMutation';
import { Therapist, LoginRequest } from '_api/types';
// import { useLoginRefresh } from 'utils/hooks';

export const SIGN_IN_QUERY_KEY = 'sign-in';

export const useLogin = () => {
  // const { toggle } = useLoginRefresh();
  return useApiMutation<{ account: Therapist; token: string }, LoginRequest>(
    () => '/auth/sign-in-web-admin',
    'post',
    undefined,
    {
      mutationKey: [SIGN_IN_QUERY_KEY],
      onSuccess: (data) => {
        setCommonHeaders(data.token);
        // document.cookie = "XSRF-TOKEN=0; Path=/; Domain=.yourstepshealth.com; Max-Age=-1"
        // toggle();
      },
    },
  );
};
